import React, { useState, useEffect, useMemo, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import {sdk} from './sdk.js';
import {sdkLocal} from './sdkLocal.js';
import { SocialUserApp } from "./SocialUserApp";

const PeupleWallLeftSide = ({ user }) => {
    return (
        <div style={styles.container}>
            <div style={styles.header}>
                <h2>Menu rapide</h2>
            </div>
            <div style={styles.content}>
                <SocialUserApp user={user} />
            </div>
        </div>
    );
};

const styles = {
    container: {
        backgroundColor: "#f8f9fa", // Couleur douce pour le fond
        padding: "1rem", // Espacement intérieur
        borderRadius: "8px", // Coins arrondis
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", // Effet d'ombre
        height: "100%", // Ajuste à la hauteur disponible
        overflowY: "auto", // Scroll si contenu dépasse
    },
    header: {
        marginBottom: "1rem",
        borderBottom: "2px solid #dee2e6",
        paddingBottom: "0.5rem",
    },
    content: {
        display: "flex",
        flexDirection: "column",
        gap: "1rem", // Espacement entre les éléments
    },
};

export { PeupleWallLeftSide };
